import React from "react";
import Header from "../Landingpagecomponents/Header/header"
import { Grid, Typography } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Footer from "../Landingpagecomponents/Footer/Footer"
import { makeStyles } from "@material-ui/core/styles";

const Terms_conditions = () => {
    return (
    
    <Grid container xs={12} style={{backgroundColor: "#eaeaea"}}>
        <Header/>
        <Grid xs={12} style={{backgroundColor: "#002D55", height: 250}} />
        <Grid container justify="center" style={{marginTop: 20}}>
            <Paper item xs={12}  style={{width: "70%", margin: 20, padding: 20}}>
                <Typography style={{justify: "center", justifyContent: "center", alignText: "center", backgroundColor: "#FFFFFF", color: "#002D55"}}>
                    <h1>Terms and conditions for use of our service</h1>
                    <h2 style={{color: "#002D55"}}>Information we may collect about you</h2>
                    <p>
                        text
                    </p>
                    <h2 style={{color: "#002D55"}}>Uses made of the information</h2>
                    <p>
                        text
                    </p>
                    <h2 style={{color: "#002D55"}}>Other uses of information we collect about you</h2>
                    <p>
                        text
                    </p>
                    <h2 style={{color: "#002D55"}}>Other uses of information we receive from other sources</h2>
                    <p>
                        text
                    </p>
                    <h2 style={{color: "#002D55"}}>Service providers</h2>
                    <p>
                        text
                    </p>
                    <h2 style={{color: "#002D55"}}>Access to information</h2>
                    <p>
                        text
                    </p>
                    <h2 style={{color: "#002D55"}}>Changes to our privacy policy</h2>
                    <p>
                        text
                    </p>
                </Typography>
            </Paper>
        </Grid>
    <Grid xs={12} container justify="center" justifyContent="center">
        <Footer />
    </Grid>
    </Grid>
    );
};

export default Terms_conditions;